<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title"><i class="fa fa-eye mr-5"></i>{{$route.params.type === 'orders' ? 'open_orders' : 'not_booked_returns'  | translate}}</h3>
        <div class="box-tools pull-right">
          <button type="button" class="btn btn-box-tool" data-widget="collapse">
            <i class="fa fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="box-body">
        <template v-if="loading">
          <div class="row">
            <div class="col-xs-12 text-center">
              <img class="loading-gif" src="/static/img/blabla.svg"/>
            </div>
          </div>
        </template>
        <template v-else-if="Object.keys(rows).length > 0">
          <div id="accordion-test-2" class="panel-group joined">
            <div class="panel panel-default" v-for="(row, index) in rows">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a :href="`#collapse-${index}`" data-parent="#accordion-test-2" data-toggle="collapse">{{row.name}} - {{row.email}}</a>
                  <router-link :to="'/accounting/companies/' + row.company_id" target="_blank"><button class="btn btn-xs pull-right btn-info"><i class="fa fa-external-link"></i></button></router-link>
                </h4>
              </div>
              <div :id="`collapse-${index}`" class="panel-collapse collapse in">
                <div class="panel-body" v-if="$route.params.type !== 'returns'">
                  <template v-for="order in row.data">
                    <div :class="['col-xs-6', 'col-lg-3', isOld(order.occured_at) ? 'text-danger' : '']">
                      <router-link :to="`/orders/${order.order_id}`" target="_blank"><strong>{{'order_id' | translate}}: </strong> {{order.order_id}}<i class="fa fa-external-link ml-5"></i></router-link><br/>
                      <strong>{{'sales_channel' | translate}}:</strong> <img class="img-responsive img-channel" :src="getImgUrl(order)"><br/>
                      <strong>{{'date' | translate}}:</strong> <span class="italic small">{{order.occured_at | orderDate}} <i class="fa fa-clock-o mr-5"></i>{{order.occured_at | orderDate(true)}}<hr v-if="row.data.length > 1"></span>
                    </div>
                  </template>
                </div>
                <div class="panel-body" v-else>
                  <template v-for="order in row.data">
                    <div :class="['col-xs-6', 'col-lg-4', isOld(order.occured_at) ? 'text-danger' : '']">
                      <router-link :to="`/orders/${order.order_id}`" target="_blank"><strong>{{'order_id' | translate}}: </strong> {{order.order_id}}<i class="fa fa-external-link ml-5"></i></router-link><br/>
                      <strong>{{'merchant_article_number' | translate}}: </strong>{{order.erp_article_number}}<br/>
                      <strong>{{'sales_channel' | translate}}:</strong> <img class="img-responsive img-channel" :src="getImgUrl(order)"><br/>
                      <strong>{{'return_date' | translate}}:</strong> <span class="italic small">{{order.occured_at | orderDate}} <i class="fa fa-clock-o mr-5"></i>{{order.occured_at | orderDate(true)}}</span><br/>
                      <strong>{{'order_date' | translate}}:</strong> <span class="italic small">{{order.order_date | orderDate}} <i class="fa fa-clock-o mr-5"></i>{{order.order_date | orderDate(true)}}</span><br/>
                      <strong>{{'days_since_return' | translate}}:</strong> <span>{{order.date_diff}}<hr v-if="row.data.length > 1"></span>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="callout callout-info">
            <h4><i class="fa fa-exclamation-triangle mr-5"></i>Info</h4>
            <p v-if="$route.params.type === 'returns'">Aktuell liegen uns keine nicht verbuchten Retouren vor, die älter als 16 Stunden sind</p>
            <p v-else>Aktuell liegen uns keine offenen Bestellungen die älter als 12 Stunden sind vor, die nicht versendet sind.</p>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>
<script>
  export default {
    data () {
      return {
        alerts: [],
        ready: [],
        rows: [],
        loading: true
      }
    },
    methods: {
      getData () {
        API.get(`observation/${this.$route.params.type}`, {})
          .then(response => {
            this.rows = response.data
            this.loading = false
          })
          .catch(error => {
            this.checkError(error)
          })
      },
      isOld (date) {
        let d = moment(date, 'DD.MM.YYYY HH:mm:ss')
        let easter = this.getEaster(d.year())
        let easterMonday = moment().year(d.year()).month(easter[1]).date(easter[0]).add(1, 'd')
        let christi = moment().year(d.year()).month(easter[1]).date(easter[0]).add(39, 'd')
        let pfsonn = moment().year(d.year()).month(easter[1]).date(easter[0]).add(49, 'd')
        let pfmon = moment().year(d.year()).month(easter[1]).date(easter[0]).add(50, 'd')
        let fronl = moment().year(d.year()).month(easter[1]).date(easter[0]).add(60, 'd')
        let holidays = [
          '01.01',
          '06.01',
          `${easter[0]}.${easter[1] < 10 ? `0${easter[1]}` : easter[1]}`, // Easter sunday
          `${easterMonday.date() < 10 ? `0${easterMonday.date()}` : easterMonday.date()}.${easterMonday.month() < 10 ? `0${easterMonday.month()}` : easterMonday.month()}`, // Easter monday
          `${christi.date() < 10 ? `0${christi.date()}` : christi.date()}.${christi.month() < 10 ? `0${christi.month()}` : christi.month()}`, // Christi Himmelfahrt
          `${pfsonn.date() < 10 ? `0${pfsonn.date()}` : pfsonn.date()}.${pfsonn.month() < 10 ? `0${pfsonn.month()}` : pfsonn.month()}`, // Pfingstsonntag
          `${pfmon.date() < 10 ? `0${pfmon.date()}` : pfmon.date()}.${pfsonn.month() < 10 ? `0${pfmon.month()}` : pfmon.month()}`, // Pfingstmontag
          `${fronl.date() < 10 ? `0${fronl.date()}` : fronl.date()}.${fronl.month() < 10 ? `0${fronl.month()}` : fronl.month()}`, // Fronleichnam
          '01.05',
          '03.10',
          '26.10',
          '01.11',
          '08.12',
          '24.12',
          '25.12',
          '26.12']
        let checkDate = date.split('.')
        let timeDiff = 32
        if (holidays.includes(`${checkDate[0]}.${checkDate[1]}`)) {
          timeDiff += 24
        }
        if (d.day() > 3) {
          if (d.day() === 4 && d.hour() >= 16) {
            timeDiff += (6 - d.day()) * 24
          }
        }
        return moment().diff(d, 'hours') > timeDiff
      },
      getImgUrl (order) {
        let channel = this.$store.getters.salesChannels.find(x => {return x.id === order.sales_channel_id})
        return channel && channel ?  `/static/img/${channel.img}` : `/static/img/no-img.png`
      },
      getEaster (year) {
        let f = Math.floor,
          // Golden Number - 1
          G = year % 19,
          C = f(year / 100),
          // related to Epact
          H = (C - f(C / 4) - f((8 * C + 13)/25) + 19 * G + 15) % 30,
          // number of days from 21 March to the Paschal full moon
          I = H - f(H/28) * (1 - f(29/(H + 1)) * f((21-G)/11)),
          // weekday for the Paschal full moon
          J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
          // number of days from 21 March to the Sunday on or before the Paschal full moon
          L = I - J,
          month = 3 + f((L + 40)/44),
          day = L + 28 - 31 * f(month / 4)
        return [day, month]
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.getData()
      })
    },
    watch: {
      '$route.params' () {
        this.loading = true
        this.getData()
      }
    }
  }
</script>
<style>
  .date-popover {
    overflow-x: hidden;
    overflow-y: hidden;
    outline: none;
    max-width: 350px;
    width: 100%;
    border-radius: 0 0 .28571429rem .28571429rem;
    box-shadow: 0 2px 3px 0 rgba(34,36,38,.15);
    background: #212228 !important;
    transition: opacity .1s ease;
    position: relative;
    margin: auto;
    z-index: 10;
    border: 1px solid;
    font-size: 1rem;
    font-weight: 200;
  }
  .picker .monthItem .item.active:hover{
    border-top: 1px solid;
    cursor: pointer;
    background-color: rgba(0,195,150,.4) !important;
    border-color: rgba(0,195,150,1) !important;

  }
</style>
<style scoped>
  .panel {
    background-color: #282a31 !important;
  }
  .panel-heading {
    background-color: #212228 !important;
  }
  .img-responsive {
    display: inline !important;
  }
</style>
<style scoped>
  .loading-gif {
    padding-top: 8px;
    padding-bottom: 15px;
    width: 15%;
  }
  .italic {
    font-style: italic;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Overviews/Overview.vue